export default {
    Setup: 1,
    SelectTheme: 2,
    SelectCase: 3,
    Lobby: 4,
    Pages: 5,
    End: 6
}
